export class CountryViewModel {
    IdCountry: number;
    DisplayName: string;
}

